import {
  default as PhoneTransferActionsServiceName,
  PhoneTransferActionsService,
} from '@agent/agent-interface/contact-view/phone/phone-transfer-actions.service';
import { CobrowsingFacade } from '@agent/core/store/cobrowsing/cobrowsing.facade';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { State } from './';
import { PhoneCobrowsingWorkspaceComponent } from './cobrowsing/phone-cobrowsing-workspace.component';
import { default as phoneAcceptionsActionsName, PhoneAcceptingActions } from './phone-accepting-actions.component';
import { default as phoneActionsName, PhoneActions } from './phone-actions.component';
import { default as phoneActionsServiceName, PhoneActionsService } from './phone-actions.service';
import {
  default as phoneAdditionalInformationViewName,
  PhoneAdditionalInformationView,
} from './phone-additional-information-view.component';
import { default as phoneConferenceActionsName, PhoneConferenceActions } from './phone-conference-actions.component';
import { default as phoneInfoName, PhoneInfo } from './phone-info.component';
import { default as phonePostTreatmentActionsName, PhonePostTreatmentActions } from './phone-post-treatment-actions.component';
import { default as phoneQualificationWorkspaceName, PhoneQualificationWorkspace } from './phone-qualification-workspace.component';
import { default as phoneScriptRedirectionActionsName, PhoneScriptRedirectionActions } from './phone-script-redirection-actions.component';
import {
  default as phoneScriptRedirectionWorkspaceName,
  PhoneScriptRedirectionWorkspace,
} from './phone-script-redirection-workspace.component';
import { default as phoneWorkspace, PhoneWorkspace } from './phone-workspace.component.ajs';

export default module('contact.agent.contact-view.phone', [State])
  .component(phoneAcceptionsActionsName, new PhoneAcceptingActions())
  .component(phoneActionsName, new PhoneActions())
  .component(phoneConferenceActionsName, new PhoneConferenceActions())
  .component(phoneInfoName, new PhoneInfo())
  .component(phonePostTreatmentActionsName, new PhonePostTreatmentActions())
  .component(phoneQualificationWorkspaceName, new PhoneQualificationWorkspace())
  .component(phoneScriptRedirectionActionsName, new PhoneScriptRedirectionActions())
  .component(phoneScriptRedirectionWorkspaceName, new PhoneScriptRedirectionWorkspace())
  .component(phoneAdditionalInformationViewName, new PhoneAdditionalInformationView())
  .component(phoneWorkspace, new PhoneWorkspace())
  .directive(
    'cngPhoneCobrowsingWorkspace',
    downgradeComponent({ component: PhoneCobrowsingWorkspaceComponent }) as angular.IDirectiveFactory
  )
  .factory('cobrowsingFacade', downgradeInjectable(CobrowsingFacade) as any)
  .service(phoneActionsServiceName, PhoneActionsService)
  .service(PhoneTransferActionsServiceName, PhoneTransferActionsService).name;
